import { MetadataEntityFieldType } from '@jms/model';
import type { SurfaceCapability } from '@workbuddy/ui/v2/surface.engine';
import { SharingFieldRendererComponent } from './field.renderer/sharing.field.renderer.component';
import { chooseShareParent } from './share.parent';
import { loadShareValue, saveShareValue, type ShareValue } from './share.value';

/**
 * Sharing on any shareable child a candidate parent offers toggles for. Readonly follows the field: a page
 * the user cannot edit shows the current sharing without the menu, and a readonly field never patches.
 */
export const sharingCapability: SurfaceCapability<ShareValue> = {
  key: 'sharing',
  applies: context => chooseShareParent(context.entity, context.parents) !== null,
  field: {
    bind: 'sharing',
    fieldRenderer: 'sharing.editor',
    renderer: { component: SharingFieldRendererComponent },
    metadata: { type: MetadataEntityFieldType.Custom, name: 'sharing', displayName: 'Sharing' },
  },
  load: loadShareValue,
  save: saveShareValue,
};
